import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    places: Number
  }
  
  connect() {
    this.formatValue()
    
    // Apply formatting when values change
    this.element.addEventListener('change', this.formatValue.bind(this))
    this.element.addEventListener('blur', this.formatValue.bind(this))
  }
  
  formatValue() {
    const value = parseFloat(this.element.value)
    if (!isNaN(value)) {
      this.element.value = value.toFixed(this.placesValue || 1)
    }
  }
}